import * as Icons from "lucide-react";
import { ArrowUpRight } from "lucide-react";
import { SERVICES, waLink } from "@/lib/site";
import { Reveal, Stagger, StaggerItem } from "@/lib/motion";

export const Services = () => (
  <section id="servicos" className="relative py-24 lg:py-32 bg-slate-50">
    <div className="max-w-7xl mx-auto px-4 md:px-8">
      <Reveal className="max-w-2xl">
        <p className="text-sm font-bold uppercase tracking-[0.2em] text-[#55c0e0] mb-4">Nossas Soluções</p>
        <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-[#012a60] text-balance">
          Vidros temperados sob medida para cada ambiente
        </h2>
      </Reveal>

      <Stagger className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {SERVICES.map((s) => {
          const Icon = Icons[s.icon] || Icons.Square;
          return (
            <StaggerItem key={s.title}>
              <div className="shine group relative h-full overflow-hidden rounded-2xl bg-white border border-slate-200 p-7 hover:shadow-[0_18px_50px_-15px_rgba(1,42,96,0.28)] hover:border-[#55c0e0]/50 transition-all duration-500">
                <div className="flex items-center justify-between mb-6">
                  <span className="grid place-items-center h-14 w-14 rounded-xl bg-[#012a60] text-[#55c0e0] transition-transform duration-500 group-hover:-translate-y-1 group-hover:bg-[#55c0e0] group-hover:text-[#012a60]">
                    <Icon size={24} />
                  </span>
                  <span className="rounded-full bg-[#b4effe]/40 px-3 py-1 text-[11px] font-bold text-[#012a60]">
                    {s.tag}
                  </span>
                </div>
                <h3 className="font-display text-xl font-bold text-[#012a60]">{s.title}</h3>
                <p className="mt-2 text-sm text-slate-600 leading-relaxed">{s.desc}</p>
                <a
                  href={waLink(`Olá! Tenho interesse no serviço de ${s.title}. Poderia me passar um orçamento?`)}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`service-cta-${s.title}`}
                  className="mt-6 inline-flex items-center gap-1.5 text-sm font-bold text-[#012a60] hover:text-[#55c0e0] transition-colors"
                >
                  Solicitar orçamento
                  <ArrowUpRight size={15} className="transition-transform group-hover:translate-x-0.5" />
                </a>
              </div>
            </StaggerItem>
          );
        })}
      </Stagger>
    </div>
  </section>
);
